<script setup>
import { ref } from "vue";
import ReviewForm from "@/components/frontend/review/ReviewForm.vue";
import Modal from "@/components/frontend/ui/Modal.vue";
import StarRating from "@/components/frontend/review/StarRating.vue";

const showSuccessMessage = ref(false);
const review = ref(null);
const openModal = ref(false);

function handleSuccess(e) {
  showSuccessMessage.value = true;
  review.value = e.review;
}
</script>
<template>
    <div>
        <div>
            <StarRating v-if="review" :rating="review.rating" :opinions="$attrs.opinionsTranslations" disabled></StarRating>
            <button v-else type="button" class="btn btn-primary btn-lg" @click="openModal = true">
                <slot></slot>
            </button>
        </div>

        <Modal :title="$t('Give us your opinion')"
               :show="openModal"
               size="lg"
               @hidePrevented="openModal = false"
               @hide="openModal = false"
        >
          <div v-if="showSuccessMessage">
            <div class="text-center">
              <h3>{{ $t('Thank you for your review!') }}</h3>
              <h1 class="display-2 m-5">👍</h1>
            </div>
          </div>
          <template v-else>
            <ReviewForm  v-bind="$attrs"  v-on:successfully-submitted="handleSuccess($event)" class="p-2"></ReviewForm>
          </template>
        </Modal>
    </div>
</template>